import { Log } from '@lightningjs/sdk'
import { AppApiConfig } from './app-api-config'
import { Config } from './config'
import AppModel from './models/app-model'
import SessionTimeState from './session-time-state'

export class AppState {
    backHist = []

    appStack: AppModel[] = [] //

    showSubtitle = false;
    eventInProgress:boolean = false;
    // user actions
    userAction = {
        actiontype: '',
        actionkey: '',
        Xactionindex: 0,
        Yactionindex: 0,
        errorcode: '',
        errormsg: ''
    };

    player = {
        currentUserAction: '',
        videoSkippedCount: 0,
        hlsError: false,
        pausedTime: 0,
        videoStartedFromResumePoint: 0,
        noVideosStarted: 0,
        vodAutoPlayed: false,
        userInteraction: false,
        noVideosPlayed: 0,
        trailersPlayedInSession: [] as string[],
        ignoredAutoplayNodes: [] as string[],
        noVideosSinceLastBugAd: 0
    };

    sessionTimeState: SessionTimeState = new SessionTimeState()

    videoMode = false;
    appUnload = false;
    gridMode = false;

    titleFontFamily = '';
    bodyFontFamily = '';

    playlistPlayMode = false;
    isDeeplinkInterupped = false;
    showDeeplinkSorryMsgOnGrid = false;
    // deep linking
    deeplinks = {
        playId: '',
        payloadStr: '',
        type: 'movie',
        sourceType: 'hs-search',
        isInvalidPattern: false
    };

    constructor(appConfig: Config) {
        const appModel: AppModel = new AppModel(appConfig.siteId, true)
        Log.info('appModel', appModel)
        this.appStack.push(appModel)
    }

    clearDeeplink() {
        this.playlistPlayMode = false;
        this.isDeeplinkInterupped = false;
        // deep linking
        this.deeplinks = {
            playId: '',
            payloadStr: '',
            type: 'movie',
            sourceType: 'hs-search',
            isInvalidPattern: false
        };
    }

    getApp(): AppModel | undefined {
        return this.appStack[this.appStack.length - 1]
    }

    getAppApiConfig(): AppApiConfig | undefined {
        return this.getApp()?.appApiConfig
    }
}
